import React from "react";
const Home = () => {
    return <h4>Welcome Admin !</h4>;
};
export default Home;
